import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';
import { columnsServerlessTask } from './type';

type Props = {
  data: columnsServerlessTask[];
  isLoading?: boolean;
  onClickRow: (id: string) => void;
  isShowProjectId?: boolean;
  isShowCost?: boolean;
};
const TasksTable = ({
  data,
  isLoading,
  onClickRow,
  isShowProjectId,
  isShowCost,
}: Props) => {

  return (
    <div className="">
      <DataTable
        columns={columns({
          isShowProjectId,
          isShowCost,
        })}
        data={data}
        slots={{
          pagination: {
            isSelectPageSize: false,
          },
        }}
        isLoading={isLoading}
        onClickRow={(row) => {
          onClickRow(row.original?.id);
        }}
      />
    </div>
  );
};

export default TasksTable;
